import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20cinematic%20composition%20with%20flowing%20golden%20and%20crimson%20silk%20ribbons%20on%20deep%20charcoal%20background%2C%20film%20reel%20texture%20overlay%2C%20dramatic%20lighting%2C%20elegant%20oriental%20aesthetic%2C%20luxury%20cinema%20atmosphere%2C%20soft%20bokeh%20particles%2C%20clean%20minimal%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="亚洲国产高清影视内容精选平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          亚洲国产高清影视内容精选平台
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          发现优质亚洲本土影视内容的最佳入口，汇聚亚洲各地国产高清剧集、电影与综艺，
          画质清晰、资源丰富，满足您对亚洲国产高清内容的全方位需求。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/drama"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-label font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            探索热门剧集
          </Link>
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-label font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap"
          >
            发现高清电影
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          {[
            { value: '5000+', label: '影视内容' },
            { value: '98%', label: '高清画质' },
            { value: '12+', label: '亚洲地区' },
            { value: '50万+', label: '活跃用户' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}